export const LABEL_LOGIN_LINK = 'login link - global header';
export const LABEL_REGISTER_LINK = 'register link - global header';
export const LABEL_PAGEVIEW_LIMIT = 'pageview limit reached';
export const LABEL_SAVE_ITEM = 'save item - product page';
export const LABEL_CONTACT_LINK = 'contact link in pdp';
